import { ProfileDataDiscriminator } from '@mews-commander/data-access';
import { CoproductElement } from '@mews/std';

interface PersonalProfileValue {
    userId: string;
    email: string;
}
interface EnterpriseProfileValue extends PersonalProfileValue {
    enterpriseId: string;
}
interface SystemProfileValue {
    name: string;
}
interface IntegrationProfileValue {
    integrationId: string;
}

export type AnonymousProfileData = CoproductElement<ProfileDataDiscriminator.AnonymousProfile, SystemProfileValue>;
export type EnterpriseProfileData = CoproductElement<
    ProfileDataDiscriminator.EnterpriseProfile,
    EnterpriseProfileValue
>;
export type IntegrationProfileData = CoproductElement<
    ProfileDataDiscriminator.IntegrationProfile,
    IntegrationProfileValue
>;
export type JobProfileData = CoproductElement<ProfileDataDiscriminator.JobProfile, SystemProfileValue>;
export type PersonalProfileData = CoproductElement<ProfileDataDiscriminator.PersonalProfile, PersonalProfileValue>;
export type PlatformProfileData = CoproductElement<ProfileDataDiscriminator.PlatformProfile, PersonalProfileValue>;
export type SystemProfileData = CoproductElement<ProfileDataDiscriminator.SystemProfile, SystemProfileValue>;

export type ProfileData =
    | AnonymousProfileData
    | EnterpriseProfileData
    | IntegrationProfileData
    | JobProfileData
    | PersonalProfileData
    | PlatformProfileData
    | SystemProfileData;

export const isEnterpriseProfileData = (profileData: ProfileData): profileData is EnterpriseProfileData =>
    profileData.discriminator === ProfileDataDiscriminator.EnterpriseProfile;

export const isIntegrationProfileData = (profileData: ProfileData): profileData is IntegrationProfileData =>
    profileData.discriminator === ProfileDataDiscriminator.IntegrationProfile;

export const isPersonalProfileData = (profileData: ProfileData): profileData is PersonalProfileData =>
    profileData.discriminator === ProfileDataDiscriminator.PersonalProfile;

export const isLikePersonalProfileData = (profileData: ProfileData): profileData is PersonalProfileData =>
    profileData.discriminator === ProfileDataDiscriminator.PersonalProfile ||
    profileData.discriminator === ProfileDataDiscriminator.PlatformProfile ||
    profileData.discriminator === ProfileDataDiscriminator.EnterpriseProfile;
